<div class="business-menu post-box-shadow hpanel">
  <ul class="panel-body pad-0 border-radius-top-left-right-6 custom-panel">
    <li class="navmenu" [class.active]="selectMenu === 'ALL'">
      <a class="navIteam" (click)="onSelect('ALL')">
        <div class="sideNavIcon">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path class="menu-icon" d="M4 6H20M4 12H20M4 18H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="nav-text">All</div>
      </a>
    </li>
    <li class="navmenu" [class.active]="selectMenu === 'USER'">
      <a class="navIteam" (click)="onSelect('USER')">
        <div class="sideNavIcon">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path class="menu-icon" d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="menu-icon" d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="menu-icon" d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="menu-icon" d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="nav-text">People</div>
      </a>
    </li>
    <li class="navmenu" [class.active]="selectMenu === 'BUSINESS_PAGE'">
      <a class="navIteam" (click)="onSelect('BUSINESS_PAGE')">
        <div class="sideNavIcon">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path class="menu-icon" d="M3 21H21M3 7V21M21 7V21M9 21V17C9 15.8954 9.89543 15 11 15H13C14.1046 15 15 15.8954 15 17V21M6 11H6.01M6 15H6.01M18 11H18.01M18 15H18.01M12 11H12.01M3 7L12 3L21 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="nav-text">Business</div>
      </a>
    </li>
    <!-- <li class="navmenu" [class.active]="selectMenu === 'COMMUNITY_PAGE'">
      <a class="navIteam" (click)="onSelect('COMMUNITY_PAGE')">
        <div class="sideNavIcon">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
            <path class="menu-icon" d="M12 2L2 7L12 12L22 7L12 2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="menu-icon" d="M2 17L12 22L22 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="menu-icon" d="M2 12L12 17L22 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="nav-text">Communities</div>
      </a>
    </li> -->
  </ul>
</div>
